module.exports = __webpack_public_path__ + "img/1.c98bae28.jpg";